<div class="modal-header">
	<h5 class="modal-title">{{chapterLesson.lesson.name}} ({{chapterLesson.lesson.studyLevel}}), {{chapterLesson.chapter.name}}</h5>
	<button type="button" class="close" aria-label="Close" (click)="close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body p-5">
  <p *ngIf="!showIframe">Geef hieronder aan welke onderdelen je wilt weergeven in de PDF.</p>

	<div *ngIf="chapterLesson['lesson']['type'] != 'TERMS' && !showIframe">
		<div class="custom-control custom-switch">
			<input type="checkbox" class="custom-control-input" id="showContent" [ngModelOptions]="{standalone: true}" [(ngModel)]="showContent">
			<label class="custom-control-label" for="showContent">Lesstof (aan/uit)</label>
		</div>
		<div class="custom-control custom-switch" *ngIf="false">
			<input type="checkbox" class="custom-control-input" id="showPictures" [ngModelOptions]="{standalone: true}" [(ngModel)]="showPictures">
			<label class="custom-control-label" for="showPictures">Afbeeldingen (aan/uit)</label>
		</div>
		<div class="custom-control custom-switch" *ngIf="chapterLesson['lesson']['hasAnswers'] == true || chapterLesson['lesson']['type'] == 'TERMS'">
			<input type="checkbox" class="custom-control-input" id="showAssignments" [ngModelOptions]="{standalone: true}" [(ngModel)]="showAssignments">
			<label class="custom-control-label" for="showAssignments">Opdrachten (aan/uit)</label>
		</div>
		<div class="custom-control custom-switch" *ngIf="showAssignments == true && (chapterLesson['lesson']['hasAnswers'] == true || chapterLesson['lesson']['type'] == 'TERMS')">
			<input type="checkbox" class="custom-control-input" id="showAssignmentLines" [ngModelOptions]="{standalone: true}" [(ngModel)]="showAssignmentLines">
			<label class="custom-control-label" for="showAssignmentLines">Invulvakken (aan/uit)</label>
		</div>
	</div>
	<div *ngIf="chapterLesson['lesson']['type'] == 'TERMS' && !showIframe">
		<div class="custom-control custom-switch">
			<input type="checkbox" class="custom-control-input" id="showTerms" [ngModelOptions]="{standalone: true}" [(ngModel)]="showTerms">
			<label class="custom-control-label" for="showTerms">Begrippen (aan/uit)</label>
		</div>
		<div class="custom-control custom-switch">
			<input type="checkbox" class="custom-control-input" id="showDefinitions" [ngModelOptions]="{standalone: true}" [(ngModel)]="showDefinitions">
			<label class="custom-control-label" for="showDefinitions">Definities (aan/uit)</label>
		</div>
		<div class="custom-control custom-switch">
			<input type="checkbox" class="custom-control-input" id="showDefinitionLines" [ngModelOptions]="{standalone: true}" [(ngModel)]="showDefinitionLines">
			<label class="custom-control-label" for="showDefinitionLines">Invulvakken (aan/uit)</label>
		</div>
	</div>
	<div *ngIf="showIframe">
		<iframe [src]="iframeSrc"></iframe>
	</div>
</div>
<div class="modal-footer" *ngIf="button">
	<button (click)="confirm()" type="submit" class="btn btn-success">{{button}}</button>
</div>
